import {Component, Input, OnChanges, OnInit, SimpleChanges, Inject, OnDestroy} from '@angular/core';
import {EventGroupListItem} from "@biletix/core/models/event/event-group-list-item.model";
import {TranslateService} from "@ngx-translate/core";
import {BtxPerformanceListItem} from "@biletix/core/models/event/performance-list-item.model";
import { APP_BASE_HREF } from "@angular/common";
import { Subscription } from 'rxjs';

@Component({
    standalone: false,
    selector: 'btx-list-item',
    templateUrl: './list-item.component.html',
    styleUrls: ['./list-item.component.scss']
})
export class ListItemComponent implements OnInit, OnChanges, OnDestroy {

    @Input() listItem!: BtxPerformanceListItem;

    @Input() region?: string;
    @Input() lang?: string;

    firstDate: string | number | Date = new Date();
    lastDate: string | number | Date = new Date();

    timeFormat = "HH:mm"
    dayFormat = "d"
    monthFormat = "LLLL"

    statusText: string = '';
    private translateSub?: Subscription;

    constructor(private translateService: TranslateService,@Inject(APP_BASE_HREF) private baseHref: string) {

    }

    ngOnInit(): void {
        this.firstDate = this.listItem.firstPerformanceDate as Date;
        this.lastDate = this.listItem.lastPerformanceDate as Date;
        this.translateSub = this.translateService.stream("performance.status." + this.listItem?.status)
            .subscribe((translatedValue) => {
                this.statusText = translatedValue;
            });
    }

    ngOnDestroy(): void {
        this.translateSub?.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.firstDate = this.listItem.firstPerformanceDate as Date;
        this.lastDate = this.listItem.lastPerformanceDate as Date;
    }

    performanceItemClasses() {
        return {
            'sold-out': !this.listItem.active
        }
    }

    generateHref(eventCode?: string, region?: string, lang?: string, keyUrlText?: string): string {
      if (!eventCode || !region || !lang) {
        return '';
      }
      if (keyUrlText) {
        return `${this.baseHref}etkinlik/${eventCode}/${region}/${lang}/${keyUrlText}`;
      }
      return `${this.baseHref}etkinlik/${eventCode}/${region}/${lang}`;
    }

    statusClasses() {
        return {
            success: this.listItem.status === "s01_onsale",
            'status-sold-out': this.listItem.status === "s02_soldout",
            'status-soon': this.listItem.status === "s03_soon",
            'status-canceled': this.listItem.status === "s04_canceled",
            'status-postponed': this.listItem.status === "s05_postponed",
            'status-boxoffice': this.listItem.status === "s06_boxoffice",
            'status-otherchannelwbox': this.listItem.status === "s15_other_channel_list_with_boxoffice",
            'status-checkback': this.listItem.status === "s12_check_back_later",
            'status-oldover': this.listItem.status === "s13_old_over",
            'status-other': this.listItem.status === "s14_other_channels"
        }
    }
}
